import{a as r}from"./chunk-BQ7L2B6F.js";var s=class extends r{constructor(){super(sessionStorage,"kik_rest_cache_")}};export{s as a};
